import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcDefaultCarousel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 538,
	height: 474,
	viewBox: "0 0 538 474",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1,
		y: 1,
		width: 530,
		height: 472,
		rx: 19,
		stroke: "currentColor",
		strokeOpacity: .5,
		strokeWidth: 2,
		strokeLinejoin: "bevel",
		strokeDasharray: "15 15"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M298.632 214.947V229.268C298.632 229.268 289.101 229.316 289.053 229.268V214.947H274.684C274.684 214.947 274.732 205.416 274.684 205.368H289.053V191H298.632V205.368H313V214.947H298.632ZM284.263 234.105V219.737H269.895V205.368H231.579C226.311 205.368 222 209.679 222 214.947V272.421C222 277.689 226.311 282 231.579 282H289.053C294.321 282 298.632 277.689 298.632 272.421V234.105H284.263ZM231.579 272.421L245.947 253.263L255.526 267.632L269.895 248.474L289.053 272.421H231.579Z",
		fill: "currentColor"
	})]
});
export default SvgIcDefaultCarousel;
